import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AdminSidenavService } from '../../../admin-navigation/services/admin-sidenav.service';

@Component({
  standalone: false,
  selector: 'app-outlet',
  templateUrl: './outlet.component.html',
  styleUrls: ['./outlet.component.scss'],
})
export class OutletComponent {
  isContentRoute = false;

  constructor(
    public adminSidenavService: AdminSidenavService,
    private readonly router: Router,
  ) {
    this.updateContentRoute(this.router.url);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.updateContentRoute(event.urlAfterRedirects || event.url);
      });
  }

  toggle() {
    this.adminSidenavService.toggle();
  }

  private updateContentRoute(url: string) {
    this.isContentRoute = url.startsWith('/private/data-sources/content');
  }
}
